//libs
import React, { memo } from 'react';
import get from 'lodash/get';

//redux
import { useSelector } from 'react-redux';

//components
import AdPlatformErrorPage from 'shared/layouts/Listing/ErrorWrapperV2/components/AdPlatformErrorPage';

//types
import { ILandingPageWidget } from 'shared/components/AdPlatformWidgets/types';

//hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

//helpers
import { getSearchText } from 'shared/store/listingV2/helpers';
import { getTransformedAdPlatformWidgets } from 'shared/layouts/Listing/helpers';

//selectors
import {
  getLocation,
  getAdPlatformWidgets,
  getAdPlatformWidgetsData,
} from 'shared/store/listingV2/selectors';

//defs
import { ErrorDetails } from 'shared/layouts/Listing/ErrorWrapperV2/types';

interface AdPlatformErrorWrapperProps {
  searchPage?: boolean;
  errorDetails: ErrorDetails;
  onButtonClick?: VoidFunction;
}

function AdPlatformErrorWrapper({
  searchPage = false,
  errorDetails,
  onButtonClick,
}: AdPlatformErrorWrapperProps) {
  const {
    enabled: isEmptySearchWidgetEnabled = false,
    dataBannerName: searchWidgetDataBannerName = '',
    dwebDataBannerName: searchWidgetDwebDataBannerName = '',
  } = useRemoteConfig('emptyResultWidget');

  const {
    enabled: isNoCategoryWidgetEnabled = false,
    dataBannerName: noCategoryDataBannerName = '',
  } = useRemoteConfig('noCategoryWidget');

  const location = useSelector(getLocation);
  const adPlatFormData = useSelector(getAdPlatformWidgets);
  const widgets = useSelector(getAdPlatformWidgetsData);
  let transformedWidgets: ILandingPageWidget[] = [];
  
  if (widgets && isEmptySearchWidgetEnabled && searchPage) {
    const searchText = getSearchText(location.search);
    let subtitle = get(adPlatFormData, 'sub_title', '');
    subtitle = subtitle.replace('{$}', searchText);

    transformedWidgets = getTransformedAdPlatformWidgets(
      widgets,
      adPlatFormData,
      searchWidgetDataBannerName,
      searchWidgetDwebDataBannerName,
      subtitle
    );
  } else if (widgets && isNoCategoryWidgetEnabled) {
    transformedWidgets = getTransformedAdPlatformWidgets(
      widgets,
      adPlatFormData,
      noCategoryDataBannerName
    );
  }

  const props = {
    emptyWidgetEnabled: searchPage ? isEmptySearchWidgetEnabled : isNoCategoryWidgetEnabled,
    widgets: transformedWidgets,
    pageName: searchPage ? searchWidgetDataBannerName : noCategoryDataBannerName,
  };

  return (
    <AdPlatformErrorPage {...props} errorDetails={errorDetails} onButtonClick={onButtonClick} />
  );
}

export default memo(AdPlatformErrorWrapper);
